import { ICommandBase } from '@/commands/interface/iCommandBase';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';

// 曲線に制御点追加コマンド
export class AddControlPointToCurveCommand implements ICommandBase
{
    private layer! : CurveLayer;
    private index! : number;
    private x! : number;
    private y! : number;
    private doneCallback! : () => void;

    constructor(layer : CurveLayer, index : number, x : number, y : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.x = x;
        this.y = y;
        this.doneCallback = doneCallback;
    }

    public do() : void
    {
        // 制御点を追加
        this.layer.insertControlPoint(this.index, this.x, this.y);

        this.doneCallback();
    }

    public undo() : void
    {
        // 追加した制御点を削除
        this.layer.removeControlPoint(this.index);

        this.doneCallback();
    }

    public redo() : void
    {
        // 制御点をindex + 1に追加
        this.layer.insertControlPoint(this.index, this.x, this.y);

        this.doneCallback();
    }
}